<template>
  <button @click="exportCreditDeposit" class="btn btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus ok-only ok-title="Cancel" @ok="close">
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportCreditDeposit: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 1000;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/promotion', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            code: item.code,
            description: item.description,
            type: this.$t(item.type),
            amountMoney: item.amountMoney,
            amountDay: item.amountDay,
            maxNumberUse: item.maxNumberUse,
            amount: item.amount,
            startTime: moment(item.startTime).format('DD/MM/YYYY HH:mm:ss'),
            endTime: moment(item.endTime).format('DD/MM/YYYY HH:mm:ss'),
            client: item.client && item.client.length ? item.client.map(c => `${c.companyName} (${c.domain})`).join(", ") : '',
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            updateTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            active: item.active ? this.$t('activated') : this.$t('deactivated')
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);
      if (!this.cancelRequest) {
        workbook.xlsx.writeBuffer({base64: true}).then(data => {
          this.exporting = false;
          saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
              'promotion.xlsx');
        }).finally(() => {
          this.cancelRequest = false;
          this.downloadedCount = 0;
        });
      }
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('code'), key: 'code', width: 15},
        {header: 'description', key: 'description', width: 15},
        {header: this.$t('type'), key: 'type', width: 15},
        {header: this.$t('amountMoney'), key: 'amountMoney', width: 15},
        {header: this.$t('amountDay'), key: 'amountDay', width: 15},
        {header: this.$t('maxNumberUse'), key: 'maxNumberUse', width: 15},
        {header: this.$t('amount'), key: 'amount', width: 15},
        {header: this.$t('startTime'), key: 'startTime', width: 15},
        {header: this.$t('endTime'), key: 'endTime', width: 15},
        {header: this.$t('client'), key: 'client', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 15},
        {header: this.$t('updateTime'), key: 'updateTime', width: 15},
        {header: this.$t('active'), key: 'active', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        promotions: 'Promotions',
        endTime: 'End time',
        startTime: 'Start time',
        desc: 'Description',
        multipleUse: 'Multiple use',
        codeInfo: 'Code information',
        code: 'Code',
        description: 'Description',
        createdBy: 'Created by',
        updatedBy: 'Updated by',
        maxNumberUse: "Số lần sử dụng tối đa/1 khách hàng",
        amount: "Số lượng mã khuyến mại",
        deposit: "Tặng tiền",
        planOrder: "Tặng gói dịch vụ",
        amountMoney: "Số tiền khuyến mãi",
        amountDay: "Số ngày khuyến mãi",
        day: "day"
      },
      vi: {
        promotions: 'Chương trình khuyến mãi',
        endTime: 'Thời gian kết thúc',
        startTime: 'Thời gian bắt đầu',
        desc: 'Mô tả',
        multipleUse: 'Được sử dụng nhiều lần',
        codeInfo: 'Thông tin mã khuyến mại',
        code: 'Mã khuyến mại',
        description: 'Mô tả',
        createdBy: 'Tạo bởi',
        updatedBy: 'Cập nhật bởi',
        maxNumberUse: "Số lần sử dụng tối đa/1 khách hàng",
        amount: "Số lượng mã khuyến mại",
        deposit: "Tặng tiền",
        planOrder: "Tặng gói dịch vụ",
        amountMoney: "Số tiền khuyến mãi",
        amountDay: "Số ngày khuyến mãi",
        day: "ngày"
      }
    }
  }
}
</script>
